import React from "react"
import { Layout, SEO, Cloud, HomeAbout, HomeProjects, HomeBlog, Mission, VimeoVideo, Facts, HomeTestimonial, PDFBtns } from "../components";

const IndexPage = () => (
  <Layout>
    <SEO title="Natural Silver Solutions | Professional Bio-Active colloidal silver supplement" description="Natural Silver Solutions. Professional Bio-Active colloidal silver supplement, delivers advantages no other manufacturer can match"/>
    <Cloud/>
    <HomeAbout/>
    <VimeoVideo/>
    <Facts/>
    <Mission/>
    <HomeProjects/>
    <HomeTestimonial/>
    <PDFBtns/>
    <HomeBlog/>    
  </Layout>
)

export default IndexPage
